<template>
  <div class="modifyFolderNotesComponent">
      <b-modal ref="notesModifiedModal" id="notesModifiedModal"  hide-footer title="Notes modifiées">
        <div class="text-center">
          <p>Vos notes ont bien été modifiées</p>
          <b-button class="mt-3" variant="outline-dark" @click="$bvModal.hide('notesModifiedModal')">Fermer</b-button>
        </div>
      </b-modal>

      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        color="#F9BF3B">
      </loading>

      <b-input-group class="mt-3">
       <template #append>
         <b-button variant="light" @click="modifyNotesFolder"><v-icon name="save" /></b-button>
       </template>
       <b-form-textarea
         v-model="modifyNotes" type="text"
         placeholder="Notes"
         id="modify-folder-notes-input"
         rows="2"
         maxLength="500"
         @input="$v.modifyNotes.$touch()"
         :state="$v.modifyNotes.$dirty ? !$v.modifyNotes.$error : null">
       </b-form-textarea>
      </b-input-group>

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { validationMixin } from 'vuelidate'
import { minLength, maxLength } from 'vuelidate/lib/validators'

import { APIFolder } from '@/api/APIFolder'

const apiFolder = new APIFolder()

export default {
  name: 'modifyFolderNotesComponent',
  props: {
    folderId: Number,
    token: String,
    notes: String
  },
  components: {
    Loading,
  },
  mixins: [
    validationMixin
  ],
  data() {
     return {
       modifyNotes: this.notes,
       isModifyingNotes: false,
     }
  },
  watch: {
    notes: function(newNotes) {
      this.modifyNotes = newNotes
    }
  },

  validations: {
    modifyNotes: {
      minLength: minLength(2),
      maxLength: maxLength(500),
    },
  },

  computed: {
    isLoading () {
      if (this.isModifyingNotes ) {
        return true
      }
      return false
    },
  },


  methods: {
    modifyNotesFolder () {
      this.isModifyingNotes = true
      apiFolder.modifyNotesFolder(this.token, this.folderId, this.modifyNotes)
      .then(() => {
        this.$refs.notesModifiedModal.show()
      })
      .catch((error) => {
        this.$refs.globalAPILoadingErrorModal.show()
        throw new Error('modifyFolderNotesComponent markAllCrawlPagesAsRead API Error : ' + String(error))
      })
      .finally(() => {
        this.isModifyingNotes = false
      })
    },

  }
}
</script>
